import { defineMessages } from 'react-intl';

export default defineMessages({
  aliasLabel: 'Display name',
  aliasDescription: 'Can be used to show another name to respondents of your surveys. Default is your account name.',

  logoLabel: 'Logotype',
  logoDescription: 'The account logotype is used as the default header image in your surveys.',
  logoHelp: 'Click to upload. Supported formats: JPEG, PNG, WebP, GIF, SVG, TIFF',

  personalDataControllerLabel: 'Personal Data Controller',
  personalDataControllerDescription: 'Contact us if you want to change this.',
  personalDataControllerInformation: 'As the Personal Data Controller you are responsible for any personal data collected. To collect survey responses you need to add a privacy policy for each language you are using in your surveys. Extellio is the Personal Data Processor.',
  privacyPolicyLabel: 'Survey privacy policies',
  privacyPolicyDescription: 'Add a privacy policy for each language you are presenting your surveys in. If you want to add a language you need to add it to a survey first.',
  privacyPolicyTypeLabel: 'Type',
  privacyPolicyTypeDescription: 'Your privacy policy can either be presented inline in the survey or you can provide a link to a page with your privacy policy.',
  allowPersonalDataLabel: 'Disable personal data filter',
  allowPersonalDataDescription: 'Turns off the filtering of personal data in text responses. Warning! This should be used very carefully, as it can lead to legal issues.',

  saveSuccess: 'Account settings saved!',
  saveError: 'Failed to save account settings, please try again.',

  privacy: 'Privacy & Personal data',

  scriptDescription: 'Script that should be implemented on this website',
  advancedUsers: 'Advanced users',

  email: 'Email',
  firstname: 'First name',
  lastname: 'Last name',
  phone: 'Phone number',
  authRoles: 'Account roles',
  dataSourceRoles: 'Data source roles',
  loginCount: 'Login count',
  lastLogin: 'Last login',

  editUser: 'Edit user',
  authRolesRequired: 'At least one role must be assigned',

  blockUser: 'Block user',
  unblockUser: 'Unblock user',
  removeFromCustomer: 'Remove',
  confirmRemoveUser: 'Are you sure?',
  confirmRemoveUserDescription: '{email} will no longer have access to {customer}.',
  copyInvitationLink: 'Copy invitation link',
  linkCopied: 'Invitation link is copied to your clipboard',
  linkCopyFailed: 'Failed to access your clipboard, please try copying the link below.',
  impersonate: 'Impersonate',

  inviteUser: 'Invite user',
  sendInvitation: 'Send invitation',
  invitationSent: 'An invitation has been sent to {email}',
  alreadyActive: '{email} is already an active user. No invitation has been sent, but they have been added to {customer}.',
  alreadyAccess: '{email} already has access to {customer}',

  inviteUserFailed: 'Failed to invite user, please try again later.',
  updateUserFailed: 'Failed to update user, please try again later.',

  addLicense: 'Add license',
  editLicense: 'Edit license',
  deleteLicense: 'Remove license',
  startDateLabel: 'Start date',
  endDateLabel: 'End date',
  renewalDateLabel: 'Renewal date',
  editLicenseSettings: 'Override license settings',
  intervalLabel: 'Interval',
  licenseVersionLabel: 'License version',

  billing: 'Billing',
  orders: 'Orders',
});
